<template>
  <div class="detail_main">
    <div class="is-hidden-touch">
      <div @click="$parent.show = false" class="detail_container"
        :class="{'bg_detail': bg}">
      </div>
      <section class="size_detail zero_right mt-60 pb-60 is-scrollable has-background-white">
        <div class="columns is-marginless detail_content_bg">
          <figure class="maxheight half_width is-relative" v-if="!streetView">
            <button class="button is-primary btn_StreetVieuwPann">
              <img src="@/assets/images/google-street-view.svg" class="mr-5">
              <span class="is-size-14px" @click="streetView = true">Streetview</span>
            </button>
            <img class="is-width-100p" :src="getImg(detailPanneau.srcImg)" alt="">
          </figure>
          <figure class="maxheight half_width is-relative" v-else>
            <CartoPanneau
              :streetView="streetView"
              :panneau="detailPanneau"/>
          </figure>
          <div class="half_width ml-20 mt-20 mr-20">
            <a @click="$parent.show = false"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size=""
                type="is-grid-5">
              </b-icon>
            </a>
            <h3 class="has-text-grid-1 has-text-weight-bold is-size-6 mb-20">
              Caractéristiques :</h3>
            <caracteristiques :data="detailPanneau"/>
            <div class="column mt-80 is-half is-offset-one-quarter mb-10" v-if="this.afficheButton">
              <div
                v-if="!detailPanneau.select"
                @click="controlSelect()"
                class="">
                <a class="button is-primary selection is-rounded is-size-14px has-text-weight-bold">
                  Ajouter à ma sélection
                </a>
              </div>
              <div
                v-else
                @click="controlSelect()"
                class="">
                <a class="button is-danger-2 selection has-text-white is-rounded is-size-14px has-text-weight-bold">
                  Retirer de ma sélection
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-marginless is-multiline  ml-20 mr-20">
          <div class="column is-6 is-paddingless pr-10 mt-20"
            v-if="afficherTableau(detailPanneau.budgetProrata)">
            <budget :data="detailPanneau" type="prorata"/>
          </div>
          <div class="column is-6 is-paddingless mt-20"
            v-if="afficherTableau(detailPanneau.budgetAnnuel)"
            :class="afficherTableau(detailPanneau.budgetProrata) === false
                        ? 'pl-0' : 'pl-10'">
            <budget :data="detailPanneau" type="annuel"/>
          </div>
          <div class="column is-12 mt-20 is-paddingless" v-if="detailPanneau.commentaire">
            <p class="is-size-6 has-text-grid-1 has-text-weight-bold">Argumentaire :</p>
            <p class="is-size-14px has-text-grid-1 pre-line-text">{{detailPanneau.commentaire}}</p>
          </div>
        </div>
      </section>
    </div>
    <div class="is-hidden-desktop">
      <div class="detail_container has-background-white is-overflow-y-active">

        <figure class="card-img-panneau">

          <a class="button has-text-white is-rounded has-background-grid-5 btn-back"
            @click="$parent.show = false">
            <span class="icon">
              <b-icon
                icon="chevron-left">
              </b-icon>
            </span>
            <label class="is-size-10px">Retour</label>
          </a>
          <img class="img-panneau" :src="getImg(detailPanneau.srcImg)">

        </figure>

        <b-tabs class="detail-panneau mb-60" size="is-small" v-model="valueTabs">
          <b-tab-item v-for="(item, i) in tabsItem" :key="i">
            <template slot="header">
              <span class="has-text-weight-bold" :class="{'is-underline': valueTabs === i}">
                {{item.title}}
              </span>
            </template>
            <component
              :is="item.component"
              :data="detailPanneau"
              :type="item.type"/>
          </b-tab-item>
        </b-tabs>

        <div class="navbar is-fixed-bottom button is-grid-5 radius-0" v-if="this.afficheButton"
             :class="!detailPanneau.select ? 'is-grid-5' : 'is-danger-2'"
             @click="controlSelect">
          <p class="is-size-10px has-text-weight-bold">
            {{!detailPanneau.select ? 'Ajouter à ma sélection' : 'Retirer de ma sélection'}}
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { formatDate, getImg, formatNombre } from '@/services/general/general';
import Caracteristiques from './detailPanneau/caracteristiques';
import Budget from './detailPanneau/budget';
import CartoPanneau from './CartoPanneau'

const Recommandation = createNamespacedHelpers('recommandation');
const User = createNamespacedHelpers('user');

export default {
  components: {
    Caracteristiques,
    Budget,
    CartoPanneau
  },
  props: {
    detailPanneau: Object,
    bg: Boolean,
    enseigne: String,
  },
  data: () => ({
    tabsItem: [
      { title: 'Caractéristiques', component: 'Caracteristiques' },
      { title: 'Budget Prorata', component: 'Budget', type: 'prorata' },
      { title: 'Budget Annuel', component: 'Budget', type: 'annuel' },
    ],
    valueTabs: 0,
    streetView: false,
  }),
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    ...Recommandation.mapGetters({
      societe: 'societe',
    }),
    afficheButton() {
      if (this.enseigne === 'GEANT CASINO') return false;
      if (this.enseigne === 'FRANPRIX') return false;
      if (this.enseigne === 'SUPERMACHE CASINO') return false;
      else return true;
    }
  },
  methods: {
    ...Recommandation.mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    controlSelect() {
      this.detailPanneau.select = !this.detailPanneau.select;
      if (this.detailPanneau.select) {
        this.add(this.afficheDetail(this.detailPanneau).prixTotal);
        this.addNbSelect();
      } else {
        this.substract(this.afficheDetail(this.detailPanneau).prixTotal);
        this.substractNbSelect();
      }
    },
    afficheDetail(panneau) {
      if (panneau.budgetProrata.prixNet || panneau.budgetProrata.tlpe
         || panneau.budgetProrata.fraisTechnique
         || panneau.budgetProrata.honorarires
         || panneau.budgetProrata.dateDebut
         || panneau.budgetProrata.dateFin) {
        return panneau.budgetProrata;
      }
      return panneau.budgetAnnuel;
    },
    formatDate(date) {
      return formatDate(date);
    },
    getImg(img) {
      var afficheImageGenerique = false;
      // if (this.site === 'havas') afficheImageGenerique = true;
      if (this.societe?.nom === 'STEFFEN') afficheImageGenerique = true;
      return getImg(img, afficheImageGenerique);
    },
    formatNombre(val) {
      return formatNombre(val);
    },
    afficherTableau(budget) {
      const data = cloneDeep(budget);
      delete data.afficherSurEdition;
      const show = Object.values(data).findIndex(el => el);
      if (budget.afficherSurEdition && show !== -1) return true;
      return false;
    },
  },
  mounted() {
    const elHtml = document.querySelector('html');
    const elBody = document.querySelector('body');
    elHtml.style.overflow = 'hidden';
    elBody.style.overflow = 'hidden';
  },
  destroyed() {
    const elHtml = document.querySelector('html');
    const elBody = document.querySelector('body');
    elHtml.style.overflow = '';
    elBody.style.overflow = '';
  },
}
</script>

<style>

</style>
